<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Users</span>
        </nav>
        <div class="block">
            <div class="block-content block-content-full">
                <div
                    id="DataTables_Table_0_wrapper"
                    class="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <div
                                id="DataTables_Table_1_filter"
                                class="dataTables_filter"
                            >
                                <label>
                                    Search:
                                    <input
                                        type="search"
                                        class="form-control form-control-sm"
                                        placeholder="Enter access_id or email or account number..."
                                        aria-controls="DataTables_Table_1"
                                        v-model="search"
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 table-responsive">
                            <table
                                class="table table-bordered table-striped table-vcenter js-dataTable-simple dataTable no-footer"
                                id="DataTables_Table_0"
                                role="grid"
                                aria-describedby="DataTables_Table_0_info"
                            >
                                <thead>
                                    <tr role="row">
                                        <th class="text-center" tabindex="0">
                                            #
                                        </th>

                                        <th class="text-capitalize">Name</th>
                                        <th class="text-capitalize">Email</th>
                                        <th class="text-capitalize">
                                            Access ID
                                        </th>
                                        <th class="text-capitalize">
                                            Account Number
                                        </th>
                                        <th class="text-capitalize">
                                            Account Type
                                        </th>
                                        <th class="text-capitalize">
                                            Transfer Pin
                                        </th>
                                        <th class="text-capitalize">
                                            Account Balance
                                        </th>
                                        <th class="text-capitalize">
                                            Checking Balance
                                        </th>
                                        <th class="text-capitalize">
                                            Mortgage Balance
                                        </th>
                                        <th class="text-capitalize">
                                            Card Balance
                                        </th>
                                        <th class="text-capitalize">
                                            Account Status
                                        </th>
                                        <th class="text-capitalize">
                                            Ban Status
                                        </th>
                                        <th class="text-capitalize">
                                            Transaction Status
                                        </th>
                                        <th class="text-center text-capitalize">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        role="row"
                                        class="odd"
                                        v-for="(user, index) in filteredUsers"
                                    >
                                        <td class="text-center sorting_1">
                                            {{ index + 1 }}
                                        </td>
                                        <td>
                                            <a href
                                                >{{ user.first_name }}
                                                {{ user.last_name }}
                                            </a>
                                        </td>
                                        <td>
                                            {{ user.email }}
                                        </td>
                                        <td>
                                            {{ user.access_id }}
                                        </td>
                                        <td>
                                            {{ user.account }}
                                        </td>
                                        <td>
                                            {{ user.account_type }}
                                        </td>
                                        <td>
                                            {{ user.pin }}
                                        </td>
                                        <td
                                            @click.prevent="
                                                viewInvestments(user.id)
                                            "
                                        >
                                            <a href>
                                                {{ user.curr_symbol
                                                }}{{ user.accounts.balance }}</a
                                            >
                                        </td>
                                        <td>
                                            {{ user.curr_symbol
                                            }}{{ user.accounts.card }}
                                        </td>
                                        <td>
                                            {{ user.curr_symbol
                                            }}{{ user.accounts.checking }}
                                        </td>
                                        <td>
                                            {{ user.curr_symbol
                                            }}{{ user.accounts.mortgage }}
                                        </td>
                                        <td>
                                            <span
                                                v-if="user.isActive == 0"
                                                class="text-danger"
                                            >
                                                <b>Inactive</b>
                                            </span>
                                            <span v-else class="text-success">
                                                <b>Active</b>
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                v-if="user.ban == 0"
                                                class="text-success"
                                            >
                                                <b>Active</b>
                                            </span>
                                            <span v-else class="text-danger">
                                                <b>Banned</b>
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                v-if="user.txn_ban == 0"
                                                class="text-success"
                                            >
                                                <b>Active</b>
                                            </span>
                                            <span v-else class="text-danger">
                                                <b>Inactive</b>
                                            </span>
                                        </td>

                                        <!-- <td>{{ user.created_at }}</td> -->
                                        <td>
                                            <div class="btn-group">
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-info"
                                                    data-toggle="tooltip"
                                                    title="Edit"
                                                    @click.prevent="
                                                        editUser(user.id)
                                                    "
                                                >
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-danger"
                                                    data-toggle="tooltip"
                                                    title="Delete"
                                                    @click.prevent="
                                                        deleteUser(
                                                            user.id,
                                                            user
                                                        )
                                                    "
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            processing: false,
            location: "/storage/avatars/",
            search: "",
            users: []
        };
    },
    methods: {
        editUser(id) {
            return this.$router.push({
                name: "adminUserEdit",
                params: { id: id }
            });
        },

        getUsers() {
            UsersRepository.fetchUsers().then(response => {
                this.users = response.data;
            });
        },
        deleteUser(id, user) {
            swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(result => {
                // Send request to the server
                if (result.value) {
                    UsersRepository.userDelete(id)
                        .then(response => {
                            const userIndex = this.users.findIndex(
                                p => p.id === user.id
                            );
                            this.users.splice(userIndex, 1);
                            swal.fire(
                                "Deleted!",
                                response.data.message,
                                response.data.status
                            );
                        })
                        .catch(error => {
                            if (error.response.status == 403) {
                                toast.fire({
                                    type: "error",
                                    title: "Action Unauthorized"
                                });
                            }
                            swal(
                                "Failed!",
                                "There was something wrong.",
                                "warning"
                            );
                        });
                }
            });
        }
    },
    created() {
        this.getUsers();
        Fire.$on("Refresh", () => {
            this.getUsers();
        });
    },
    computed: {
        filteredUsers() {
            return this.users.filter(user => {
                return (
                    user.access_id
                        .toLowerCase()
                        .includes(this.search.toLowerCase()) ||
                    user.email
                        .toLowerCase()
                        .includes(this.search.toLowerCase()) ||
                    user.account
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
                );
            });
        }
    }
};
</script>
